<div class="training-container">
  <app-navbar></app-navbar>

  <div class="overlay">
    <div class="holder">
      <div class="title">
        <h2>Get to develop and hone your career skills</h2>
      </div>
      <div class="btn">
        <button class="btn-agent">
          <a href="/contact-us" style="text-decoration: none; color: inherit;">
          Enroll Today
        </a></button>
      </div>
    </div>
  </div>

  <!-- Learn with HuiosPay section -->
  <div class="developer">
    <div class="dev-left" data-aos="fade-up-right" data-aos-duration="2000">
      <div class="dev-title">
        <h2>Learn with HuiosPay</h2>
      </div>
      <div class="dev-text">
        <h3>
          We have created a conducive learning environment to develop technical
          or business related skills for every individual in the society. With
          our certified and reliable tutors, we make sure all enrolled students
          get the best knowledge possible in their choice of skill learning. At
          HuiosPay you are ensured the following to succeed:
        </h3>
      </div>
      <div class="dev-bulletin">
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Course Accessibility.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Scheduled Learning.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Practical and Effective Learning Methods.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Skill Acknowledged Certificates.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dev-right" data-aos="fade-up-left" data-aos-duration="2000">
      <img src="../../../../assets/img/td2.png" alt="terminal-lock" />
    </div>
  </div>
  <!-- end of Learn with HuiosPay-->

  <!-- our courses -->
  <!-- <hr />
  <div class="our-courses" data-aos="fade-up-right" data-aos-duration="2000">
    <div class="title">
      <h2>Our courses</h2>
    </div>
    <div class="card-wrapper">
      <div class="card" *ngFor="let item of allCourse">
        <div class="img">
          <img [src]="course" alt="" />
        </div>

        <div class="content">
          <div class="course-title">
            
            <h3>
              <a href="/course-details" style="text-decoration: none; color: inherit;">
                {{ item.caption }}
                </a>
              </h3>
          </div>
          <div class="rating">
            <p style="color: red">
              <img src="../../../../assets/img/rateings.png" alt="" />{{
                item.rating
              }}
            </p>
          </div>
          <div class="duration">
            <p class="text-secondary-color">{{ item.duration }} Months</p>
          </div>
          <div class="name-price">
            <div class="name">
              <div class="name-img">
               
                  <img [src]="avatar" alt="pix" />
              </div>
              <div class="details">
                <div class="name-proper">
                  <h3>{{ item.teacherName }}</h3>
                </div>
                <div class="title-proper">
                  <p>{{ item.teacherPost }}</p>
                </div>
              </div>
            </div>
            <div class="price">
              <p class="old-price">
                <s> {{ item.oldPrice | currency : "&#8358;" }}</s>
              </p>
              <p class="new-price">
                {{ item.newPrice | currency : "&#8358;" }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- end of our courses -->
  <hr />

  <!-- feedback -->
  <!-- <div class="feedback" data-aos="fade-up-right" data-aos-duration="2000">
    <div class="title">
      <h2>Our student's feedback</h2>
    </div>

    <div
      class="card-wrapper"
      data-aos="fade-down-right"
      data-aos-duration="2000"
    >
      <div class="card" *ngFor="let item of feedbacks">
        <div class="img">
          <img [src]="item.image" alt="" />
        </div>
        <div class="course-title">
          <h3>{{ item.caption }}</h3>
        </div>

        <div class="details">
          <div class="name-proper">
            <h3>{{ item.name }}</h3>
          </div>
          <div class="title-proper">
            <p>{{ item.post }}</p>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- end of feedback -->

  <!-- Community section-->
  <app-community-section></app-community-section>
  <!--End Community section-->

  <!-- footer -->
  <app-footer></app-footer>
  <!-- end of footer -->
</div>

<app-back-to-top
  [acceleration]="2"
  [animate]="true"
  [scrollDistance]="50"
  [speed]="50"
>
</app-back-to-top>
